<div class="not-found-container">
  <h1 class="not-found-title"></h1>
  <h1 class="not-found-sub">Page Not Found</h1>

  <div class="d-flex flex-nowrap align-items-center not-found-p">
    Go to
    <div class="mims"></div> <a routerLink="/">Home Page</a>
  </div>
</div>